/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import { Tag, Button, Popconfirm } from 'antd';

export default (handleViewClicked, handleDeleteClick) => [
  {
    title: 'Due',
    dataIndex: 'dueDate',
    key: 'dueDate',
    render: (text) => (<span>{moment(text).format('Do MMM YYYY')}</span>),
  },
  {
    title: 'Student Name',
    key: 'name',
    render: (_, { user }) => (<span>{`${user?.firstName ?? ''} ${user?.lastName ?? ''}`}</span>),
  },
  {
    title: 'A/Number',
    key: 'admission_number',
    render: (_, { user }) => (<Tag color="purple">{user?.profileStudent?.admissionNumber ?? '—'}</Tag>),
  },
  {
    title: 'Status',
    key: 'status',
    render: (_, { submission }) => {
      const status = submission?.status;
      if (!status) return <Tag>NOT SUBMITTED</Tag>;
      if (status === 'PENDING') return <Tag color="orange">{status}</Tag>;
      if (status === 'ACCEPTED') return <Tag color="green">{status}</Tag>;
      return <Tag color="red">{status}</Tag>;
    },
  },
  {
    title: 'Submitted',
    key: 'submitted',
    render: (_, { submission }) => (
      <span>{submission ? moment(submission.createdAt).format('Do MMM YYYY') : '—'}</span>
    ),
  },
  {
    title: 'Rating',
    key: 'rating',
    render: (_, { submission }) => {
      const rating = submission?.rating ?? 0;
      return rating > 0 ? <Tag color="#2db7f5">{`${rating}%`}</Tag> : <Tag>{`${rating}%`}</Tag>;
    },
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <span>
        <Button onClick={() => handleViewClicked(record.userId)} type="primary" size="small">View</Button>
        <Popconfirm
          title="Are you sure to delete this submission?"
          okText="Yes"
          placement="left"
          cancelText="Cancel"
          onConfirm={() => handleDeleteClick(record.userId)}
        >
          <Button danger size="small">
            Delete
          </Button>
        </Popconfirm>
      </span>
    ),
  },
];
